import axios from "axios";
import secureLocalStorage from "react-secure-storage";
const CENTRAL_BASE_URL = process.env.REACT_APP_API_URL_CENTRAL;
// Add New Organization
export const add_general_settings = async (formData:object) => {
  const response = await axios.post(secureLocalStorage.getItem("baseURL") + "/api/general-settings", formData, {
  });
  return response.data;
}
export const add_general_settings_for_tenant = async (id: number, formData: object) => {
  const response = await axios.post(CENTRAL_BASE_URL + "/api/organisations/update/" + id, formData, {
  });
  return response.data;
}

// Get All General Settings
export const get_all_general_settings = async () => {
  let response = await axios.get(secureLocalStorage.getItem("baseURL") + "/api/general-settings");
  return response.data;
};
// Delete organization
  export const delete_organization= async (id:number) => {
    let response = await axios.delete(secureLocalStorage.getItem("baseURL") + "/api/organizations/"+id);
    return response.data;
}
// Update organization
export const update_organization = async (id:number,company:string,industry:string) => {
    let response = await axios.patch(secureLocalStorage.getItem("baseURL") + "/api/organization/status/" + id, {
      company_name:company,
      industry_id:industry,
    });
    return response.data;
  }

  // Get Single Organization Logs by ID
export const get_single_organization_log = async (id: number) => {
    let response = await axios.get(`${secureLocalStorage.getItem("baseURL")}/api/organization-log/${id}`);
    return response.data;
};
// Get All Organization Logs
export const get_all_organization_logs = async () => {
    let response = await axios.get(`${secureLocalStorage.getItem("baseURL")}/api/organization-logs`);
    return response.data;
};